import type { RouteObject } from "react-router-dom";
import AppError from "../app-error";
import InvitationsList, { invitationsListLoader } from "./List";
import NewInvitation, { newInvitationLoader } from "./New";

/**
 * Not yet spread into `main.tsx`'s root route children — see this feature's WIRING NEEDED note.
 * Shape matches every other area's `routes.tsx` (`customers/routes.tsx`, `catalogue/routes.tsx`).
 */
export const invitationsRoutes: RouteObject[] = [
  { path: "invitations", Component: InvitationsList, loader: invitationsListLoader, errorElement: <AppError /> },
  { path: "invitations/new", Component: NewInvitation, loader: newInvitationLoader, errorElement: <AppError /> },
];
